interface NewProductTHeadProps {
    isShowPrice?: boolean;
}

export default function NewProductTHead({ isShowPrice = true }: NewProductTHeadProps) {
    return (
        <div className='mx-1.5 px-2 bg-gray-300 text-gray-900 rounded py-1.5'>
            <div className='grid [grid-template-columns:2fr_1fr_0.5fr_0.5fr_auto] gap-3 w-full text-[12px] items-center'>
                <p>Name</p>
                <p>Size</p>
                {isShowPrice && (
                    <p>Price</p>
                )}
                <p>Action</p>
            </div>
        </div>
    )
}
